module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/~/_core-js@2.5.1@core-js/library/modules/_add-to-unscopables.js
// module id = 283
// module chunks = 0